import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { PlaceholderImage } from './PlaceholderImage';
import { Details } from './Details';
import { TeamWatermarkBackground } from '../../TeamWatermarkBackground';

import { useGetPlayerProfileQuery } from 'store/modules/api/statsPro-api';
import { PlayerProfileLink } from '../../common/PlayerProfileLink';

export const Player = ({
    seasonId,
    playerId,
    playerNumber,
    isAFLW = false,
    competitionCode
}) => {
    const {
        data: playerProfile,
        isFetching,
        isLoading,
        isError
    } = useGetPlayerProfileQuery({
        seasonId,
        playerId
    });

    // If player doesn't exist for season, get historic data using comp code.
    const { data: historicData } = useGetPlayerProfileQuery(
        {
            competitionCode,
            playerId
        },
        { skip: !isError }
    );

    const [imgMissing, addPlaceholder] = useState(false);

    const onErrored = () => {
        //event.target.parentNode.classList.add('has-placeholder');
        addPlaceholder((current) => !current);
    };

    const playerData = playerProfile ?? historicData;

    const teamAbbreviation = PULSE.app.common.team.getTeamAbbr(
        playerData?.team?.teamId
    );

    return (
        <>
            {playerData ? (
                <TeamWatermarkBackground
                    providerId={playerData.team.teamId}
                    className={`compare-header__watermark-bg compare-header__watermark-bg--${playerNumber}`}
                    side={playerNumber === '1' ? 'left' : 'right'}
                />
            ) : null}
            <div
                className={`compare-header__player compare-header__player--${playerNumber} ${
                    playerData
                        ? `compare-header__player--${teamAbbreviation}`
                        : ''
                } ${
                    imgMissing || (isFetching && !isLoading)
                        ? 'has-placeholder'
                        : ''
                }`}
            >
                {playerData && (
                    <PlayerProfileLink
                        classes="stats-head-to-head__player-link"
                        isAFLW={isAFLW}
                        player={{
                            playerId: playerData.playerId,
                            firstName: playerData.playerDetails.givenName,
                            surname: playerData.playerDetails.surname
                        }}
                    >
                        <img
                            className="compare-header__player-image"
                            alt={`${PULSE.I18N.lookup(
                                'label.stats.headshot.alt'
                            )} ${playerData.playerDetails.givenName} ${
                                playerData.playerDetails.surname
                            }`}
                            src={PULSE.app.common.image.migratePlayerPhotoURL(
                                playerData.playerDetails.photoURL,
                                0.5
                            )}
                            onError={(event) => onErrored(event)}
                        />
                    </PlayerProfileLink>
                )}

                {!playerData && <PlaceholderImage />}

                <Details
                    cssClass="compare-header__player-details"
                    floatingIcon="swap-action"
                >
                    {playerData ? (
                        <>
                            <span className="compare-header__team">
                                <span className="compare-header__team-label u-hide-until-tablet">
                                    {playerData.team.teamName}
                                </span>
                                <span className="compare-header__team-label u-hide-from-tablet">
                                    {playerData.team.teamAbbr}
                                </span>
                            </span>
                            <span className="compare-header__fname">
                                {playerData.playerDetails.givenName}
                            </span>
                            <span className="compare-header__lname">
                                {playerData.playerDetails.surname}
                            </span>
                            <span className="compare-header__swap-label">
                                {PULSE.I18N.lookup(
                                    'label.statsCompare.swapPlayer'
                                )}
                            </span>
                        </>
                    ) : null}
                </Details>
            </div>
        </>
    );
};

Player.propTypes = {
    seasonId: PropTypes.string.isRequired,
    playerId: PropTypes.string.isRequired,
    playerNumber: PropTypes.string.isRequired,
    isAFLW: PropTypes.bool,
    competitionCode: PropTypes.string
};
